import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { formatQueryParams } from "helpers/format";
import bannerApi from "api/bannerApi";

export const getBannerList = createAsyncThunk(
  "Banner",
  async (params: any = {}) => {
    try {
      const response = await bannerApi.getBannerList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const postBanner = async (data: any = {}) => {
  try{
    const response = await bannerApi.createBanner(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putBanner = async (id: string | number , data: any = {}) => {
  try{
    const response = await bannerApi.updateBanner(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const deleteBanner = async (id: string | number) => {
  try{
    const response = await bannerApi.deleteBanner(id);
    return response;
  }catch (error) {
    return error;
  }
};